import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfoliotarget',
  templateUrl: './portfoliotarget.component.html',
  styleUrls: ['./portfoliotarget.component.css']
})
export class PortfoliotargetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
